<template>
  <v-layout row style="padding-top:49px;"   fill-height>
      <div class="loading" v-if="loading">
        <v-layout align-center justify-center row fill-height>
          <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
              </v-progress-circular>
        </v-layout>
      </div>
    <object-dialog ref="objectDialog"  :data="dialogData" :dialog="dialogState" @closeDialog="dialogState = $event" @updateData="changeStatus($event)"></object-dialog>
    <v-snackbar  v-model="errorLoading" color="error" :timeout="timeout" top="top">
      {{errorMsg}}
    </v-snackbar>
    <v-flex xs12 sm12 class="event_body" style="background-color:rgb(247, 247, 247)">
      <v-card class="event_card" style="height:100%">
        <app-header   v-if="headerState" :hideTitle="!titleState">
          <span slot="title">Obj</span>
        </app-header>
        <v-layout class="urt_form">
            <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
                <v-card class="card_form">
                       <v-toolbar flat color="white" class="table_header" >
                           <v-flex xs9>
                              <v-text-field class="table_search" :style="[($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? {'margin-left': '-5px'} : {'margin-left': '-15px'}]" :class="{'xs_input': $vuetify.breakpoint.xs}"
                                    v-model="model"
                                    label="Search"
                                    data-vv-name="Search"
                                    solo
                                     v-on:keyup.enter="loadList"
                                     append-icon="search"
                                    @click:append="loadList"
                                    clearable
                                    @click:clear="clearSearch"
                                ></v-text-field>
                           </v-flex>
                            <v-flex xs3 style="padding-left:10px;">
                              <v-combobox
                               class="table_combo"
                                v-model="bucketModel"
                                :items="bucketList"
                                @change="loadList"
                                label="Select bucket"
                                solo
                                no-filter
                              ></v-combobox>
                            </v-flex>
                          <v-spacer></v-spacer>
                           <v-btn style="margin-top: -23px;margin-left: 10px;" fab light small class="mb-2 table_btn" :style="[($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? {'height': '30px','width': '30px'} : {}]" @click="insertJson">
                                <v-icon>add</v-icon>
                           </v-btn>
                        </v-toolbar>
                        <v-data-table
                          :headers="headerList"
                          :items="result"
                          :loading="isLoading"
                          :options.sync="pagination"
                          :server-items-length="totalItems"
                        >
                          <v-progress-linear  v-slot:progress color="blue" indeterminate></v-progress-linear>
                           <template v-slot:body="{ items }">
                            <tbody>
                              <tr style="cursor:pointer;" v-for="(item, index) in items" :key="index"  @click.stop="detailJson(item, index)">
                                <td>{{ item.name }}</td>
                                <td >{{ item.lastModified | formatTime }}</td>
                                <td >{{ item.size }}</td>
                                <td class="hidden-xs-only">{{ item.tag }}</td>
                              </tr>
                            </tbody>
                          </template>
                          <template v-slot:no-data>
                            <v-layout align-center justify-center row>
                              <v-btn color="primary" class="table_btn" small outlined light @click="loadList()">Try Fetch</v-btn>
                            </v-layout>
                          </template>
                            <template v-slot:no-results>
                            <v-layout align-center justify-center row>
                              <v-btn color="primary" class="table_btn" small outlined light @click="loadList()">Try Fetch</v-btn>
                            </v-layout>
                          </template>
                        </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import JJ from '@/assets/gitpage_icon.png';
import Clock  from '@/components/page-components/Clock';
import ObjectDialog from '@/components/page-components/object/ObjectDialog';
import BackPage from '@/components/page-components/BackPage';
import { setTimeout, setInterval } from 'timers';
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import { mapGetters } from 'vuex';
import HeaderState from '@/components/page-components/Header';
import conf from '@/config/config';

export default {
  $_veeValidate: {
        validator: 'new'
    },
    props: ['pageParams'],
     data () {
      return {
        JJ,
        value: '',
        dialogData: {},
        dialogState: false,
        deleteDialog: false,
        loading: false,
        successed: false,
        dialog: false,
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Date/Time', value: 'lastModified' },
          { text: 'Size', value: 'size',sortable: false },
          //{ text: 'Actions', value: 'name', sortable: false }
        ],
        typeList: [
          'miki',
          'object'
        ],
        bucketList: [],
        desserts: [],
        pagination: {
          rowsPerPage: 7
        },
        totalItems : 0,
        editedIndex: -1,
        editMode: false,
        editItem: {

        },
        editTempItem: {},
        dialogState: false,
        dialogLoading: false,
        dialogIsNew: false,
        dialogIndex: 0,
         eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
        },
        webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
        },
        yp:{
          ddn: conf.objstore,
          topic: '',
          func: 'object',
          args: null
        },
        errorList: [],
        error: true,
        errorLoading: false,
        errorMsg: '',
        result: [],
        isLoading: true,
        model: null,
        typeModel: 'miki',
        bucketModel: null,
        search: null,
        timeout: 3000,
        mmsReady: false,
        mms: null
      }
    },
    computed: {
       ...mapGetters([
        'headerState',
        'footerState',
        'titleState'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      headerList(){
        let bp = this.$vuetify.breakpoint;
        let vm= this
        return this.headers.filter(h => {
          if (!h.hide) return true;
          let hide = h.hide
          if (!Array.isArray(hide)) hide = [hide]
          return !hide.find(e => {
            if (typeof e === 'string') return bp[e]
          });
        });
      },
      user (){
        return this.$store.getters.user;
      }
    },
     watch: {
      dialog (val) {
        val || this.close()
      },
      pagination(){
        this.loadList();
      }
    },
    components: {
      ObjectDialog,
      Clock,
      BackPage,
      HeaderState,
    },
    directives: {
        'indicator' : {
           bind(el, binding, vnode){
              setInterval(() => {
                if(el.style.backgroundColor == 'gray'){
                    el.style.backgroundColor = '';
                }else{
                    el.style.backgroundColor = 'gray';
                }
             }, 1000);
           }
        }
    },
    async created() {
       this.startMMS();
    },
    async beforeMount() {
       await this.subscribeMMS();
    },
    beforeDestroy() {
      this.removeEvent();
    },
    methods: {
      async changeStatus(data){
        await this.loadList();
      },
      async detailJson(item, index){
          this.editTempItem = await this.loadByObject(item);
          //this.dialogData = {bucket: this.bucketModel, object: item.name, url: this.editTempItem};
          this.$refs.objectDialog.dataChanged  = {bucket: this.bucketModel, object: item.name, url: this.editTempItem};
          this.$refs.objectDialog.removeAllFiles();
          this.$refs.objectDialog.manuallyAddFile(item, this.editTempItem);
          this.editMode = false;
          this.dialogIsNew = false;
          this.dialogState = true;

      },
      insertJson(){
          if(!this.bucketModel){
            this.errorMsg = "Bucket is not selected.";
            this.error = true;
            return;
          }
          //this.dialogData = {bucket: this.bucketModel, object: ''};
          this.$refs.objectDialog.dataChanged = {bucket: this.bucketModel, object: '', url: null};
          this.$refs.objectDialog.removeAllFiles();
          this.dialogIsNew = true;
          this.editMode = true;
          this.dialogState = true;
      },
      async callDeleteJson(){
         if(!this.editItem.dialogIsNew)
            await this.deleteJson(this.editItem);
      },
      clearSearch(){
          this.model = '';
          this.loadList();
      },
      async loadBucketList(){

          if(!this.checkWebMMSState())
            return;

          this.isLoading = true;

          let res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "file://listbucket",
              payload: { }
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  this.bucketList = data.map(item => item.name);
                  if(!this.bucketModel)
                   this.bucketModel = this.bucketList[0];
                }else{
                  this.result = [];
                  this.totalItems = 0;
                }
            }


      },
      async loadList(){
         if(this.bucketList.length == 0)
             await this.loadBucketList();

          let payload;
          const { sortBy, descending, page, rowsPerPage } = this.pagination;

          let sort = {};
          if (sortBy && sortBy != "") {
              sort[sortBy] = descending ? -1 : 1;
          }else{
            sort = {name : 1};
          }

          payload = {
             bucket : this.bucketModel,
             prefix: this.model || ""
          }

          // if(!this.model || this.model.length == 0)
          // {
          //   payload.condition = {uid: this.user.Uid};

          // }

          //payload.condition.type = this.typeModel;

          console.log(payload);

          if(!this.checkWebMMSState())
            return;

          this.isLoading = true;

          let res;

          res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "file://list",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  this.result = data;
                  this.totalItems = data.length;
                }else{
                  this.result = [];
                  this.totalItems = 0;
                }
            }

      },
      async loadByObject(item){
          let payload;

          payload = {
              filetype: 'url',
              bucket: this.bucketModel,
              object: item.name
          }


          if(!this.checkWebMMSState())
            return;

          this.isLoading = true;

          let res = await this.mms.callMMS({
               topic: '',
              DDN: conf.objstore,
              func: "file://get",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  return data.replace("http://127.0.0.1:9000", conf.objstoreurl);
                }else{
                  return "";
                }
            }

      },
      checkWebMMSState(){
        if(!this.mmsReady)
        {
          this.errorMsg = "WebMMS is not connected or registered.";
          this.error = true;
          return false;
        }else return  true;

      },
      startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("obj-EiToken") || "",
            SToken: getCookie("obj-SToken") || ""
          });
      },
      async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                // if(this.eiInfo.eiName == ''){
                //   this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'urt' + this.makeId(5);
                // }
                //  if(this.eiInfo.eiTag == ''){
                //   this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                // }
                this.mmsReady = true;
                this.error = false;
             }else{
                this.mmsReady = false;
                this.error = false;
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("obj-EiToken", this.webmmsOptions.EiToken);
             setCookie("obj-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             await this.track(this.mms, 'obj', this.pageParams);

             await this.loadList();

        });

        this.mms.on('message', (method, from, data, body) => {
             this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if(typeof data == 'object' && !data.from)
              data.from = from;
            //body.sender = data;
            if(data)
            {

              //this.eventList.push(data.data);
              //this.setLog({From : from, Data: data}, 'In');

            }
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('error', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_error', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });
      },
       onJsonChange (value) {
        //console.log('change value:', value)
      },
      onJsonSave (value){
        //console.log('save value:', value);
      },
      onJsonError (error){
         //console.log('error:', error);
      }
    }
}
</script>
<style scoped>
.json_editor{
  min-height: 500px;
  height: 100%;
}
.event_body{
   /* background-color:#e9fafb; */
}
.event_card{
   box-shadow: none;
}
.header_layout{
  margin-top: -5px;
}
.event_header{
  /* background-color:#e9fafb; */
  height: 45px;
  box-shadow: none;
  padding-top: 10px;
  border:none;
  position: fixed;
  top: 0;
  z-index: 2;
}

.card_form{
      margin-top: 60px;
}

.view_footer{
   z-index: 2;
}
.flash_box{
  float: right;
  /* margin-right: -15px; */
}
.event_status{
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
  margin-top: -5px;
}
.event_status_connect{
   background-color:#08b325;
   border-color: #08b325;
}
.event_status_disconnect{
   background-color: #d22727;
   border-color: #b72626;
}
.event_header_title{
  font-weight: bold;
   font-size: 15pt;
  margin: 0;
}

.event_header .v-toolbar__content{
   height: 45px;
}
.list{
  background-color:#f2f3f3;
  padding: 0 0 0;
  box-shadow: none;
  border:none;
  margin-top: 0;
}
  .event-action{
    margin-right:15px;
    min-width: auto;
    line-height: 18pt;
  }

  .loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}

  .list-item{
    border-bottom: 1px solid #c9c8c8;
  }
.table_btn{
  text-transform: unset;
}
</style>

<style>
.v-list__tile--avatar{
   height: 35px !important;
}
.v-list__tile__sub-title {
    font-size: 10pt;
}
.event_header .v-toolbar__content{
   height: 45px !important;
       display: block;
}
.item_form .v-text-field__details{
  margin: 0 !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
td{
  vertical-align: middle !important;
}
</style>
<style>

.jsoneditor-vue{
  height: 100%;
}
.json-save-btn{
  padding: 8px 35px !important;
  margin-bottom: 20px;
}
.yp_edit > div{
      padding-left: 10px;
    padding-right: 10px;
}
div.jsoneditor-menu{
  background-color: #dfdede !important;
  border-bottom: 1px solid #bcbcbc !important;
  color: #0c0b0b !important;
}
div.jsoneditor-menu button{
  color: #0c0b0b !important;
}
div.jsoneditor{
  border: 1px solid #b2b3b4 !important;
}
div.jsoneditor-menu > button, div.jsoneditor-menu > div.jsoneditor-modes > button{
  color: #0c0b0b !important;
}
.jsoneditor-compact,.jsoneditor-format{
 color: #0c0b0b !important;
}
.jsoneditor-poweredBy{
  color: #dfdede !important;
}
.yp_toolbar .v-toolbar__content{
height: 45px !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
.table_header{
  padding: 10px;
}
.table_header .v-toolbar__content{
  height: 70px !important;
}
.table_search .v-input__control {
  min-height: 40px !important;
}
.table_combo .v-input__control {
  min-height: 40px !important;
}
</style>
